import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="ab-footer">
      <div className="ab-footer-inner">
        <div className="ab-footer-brand">
          <p className="ab-footer-name">Angler Built</p>
          <p className="ab-footer-tag">
            Fishing gear decisions, compatibility, and current prices built for
            anglers.
          </p>
        </div>

        <nav className="ab-footer-col" aria-label="Decide">
          <p className="ab-footer-heading">Decide</p>
          <Link to="/compare">Compare</Link>
          <Link to="/compatibility">Compatibility</Link>
          <Link to="/price-comparison">Prices</Link>
        </nav>

        <nav className="ab-footer-col" aria-label="More">
          <p className="ab-footer-heading">More</p>
          <Link to="/custom-builder">Builder</Link>
          <Link to="/compare-screens">Garmin Screen Finder</Link>
          <Link to="/select/battery">Battery Finder</Link>
          <Link to="/fgtn">FGTN Show</Link>
          <Link to="/ice-fishing/shows">Ice Show Calendar</Link>
          <Link to="/contact">Contact</Link>
        </nav>
      </div>

      <div className="ab-footer-bottom">
        <p>© {year} Angler Built · A Division of Alex Timm Media, LLC</p>
        <Link className="ab-footer-feedback" to="/ask-question">
          Spot a bug or have an idea? Tell us.
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
